import { TypeCamera } from "./TypeCamera"

export class Camera{
    id!: string
    name!: string
    serialNumber!: string
    typeCamera!: TypeCamera
    linkToHost!: string
    enabled!: boolean
}